export default {
  api: "https://api-dm.bp-dm.com/api/",
  api_test: "https://api-test-dm.bp-dm.com/api/",
  login: "login",
  files: "files",
  file: "file/",
};